/* global axios */
import ApiClient from '../ApiClient';

class MercadoLivreChannel extends ApiClient {
  constructor() {
    super('mercado_livre', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorizations`, payload);
  }
}

export default new MercadoLivreChannel();
